import React from "react";

import { Grid } from "@material-ui/core";

import PastTwelveMonthsTotalCosts from "./PastTwelveMonthsTotalCosts";
import LatestMonthTotalCosts from "./LatestMonthTotalCosts";
import PercentageOfRevenue from "./PercentageOfRevenue";
import TotalCostTrendsOverTimeSubtitle from "./TotalCostTrendsOverTimeSubtitle";
import CostTypeFilter from "./CostTypeFilter";
import CostTypeMeasure from "./CostTypeMeasure";
import TotalCostTrendsOverTime from "./TotalCostTrendsOverTime";

const CostOverview: React.FC = () => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
                <PastTwelveMonthsTotalCosts />
            </Grid>
            <Grid item xs={12} md={4}>
                <LatestMonthTotalCosts />
            </Grid>
            <Grid item xs={12} md={4}>
                <PercentageOfRevenue />
            </Grid>
            <Grid item xs={12}>
                <TotalCostTrendsOverTimeSubtitle />
            </Grid>
            <Grid item xs={4}>
                <CostTypeFilter />
            </Grid>
            <Grid item xs={8}>
                <CostTypeMeasure />
            </Grid>
            <Grid item xs={12}>
                <TotalCostTrendsOverTime />
            </Grid>
        </Grid>
    );
};

export default CostOverview;
